import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { LocationPropType } from '../../../services/proptypes';
import CustomerReview from '../CustomerReview/CustomerReview';
import './CustomerReviewModal.css';
var defaultProps = {
  locations: [],
  showRating: true
};

var CustomerReviewModal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CustomerReviewModal, _React$Component);

  function CustomerReviewModal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      open: false
    };
    return _this;
  }

  var _proto = CustomerReviewModal.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        businessId = _this$props.businessId,
        locations = _this$props.locations,
        showRating = _this$props.showRating;
    var open = this.state.open;
    return /*#__PURE__*/React.createElement(Modal, {
      onClose: function onClose() {
        return _this2.setState({
          open: false
        });
      },
      onOpen: function onOpen() {
        return _this2.setState({
          open: true
        });
      },
      open: open,
      dimmer: "inverted",
      className: "submit-reviews-modal",
      trigger: /*#__PURE__*/React.createElement("div", {
        className: "submit-review-button-container"
      }, /*#__PURE__*/React.createElement(Button, {
        primary: true
      }, "Submit Review"))
    }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", null, "Write a Review"), /*#__PURE__*/React.createElement(Icon, {
      name: "close",
      onClick: function onClick() {
        _this2.setState({
          open: false
        });
      }
    })), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(CustomerReview, {
      businessId: businessId,
      locations: locations,
      showRating: showRating
    })));
  };

  return CustomerReviewModal;
}(React.Component);

export { CustomerReviewModal as default };
CustomerReviewModal.defaultProps = defaultProps;